export default __webpack_public_path__ + "4d23825a269ddce9b8a8139c6bb02895.svg";